export default "__VITE_ASSET__Bw60a5IG__"